import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Parameter } from '#advertDetail/components';
import advertDetailCss from '../../assets/advert-detail.module.scss';
import advertDetailParameterListCss from '../../assets/parameter/parameter-list.module.scss';

const ParameterList: FC = () => {
  const {
    advert: {
      parameterDataList,
    },
  } = useAdvertDetailContext();

  if (parameterDataList.length === 0) {
    return null;
  }

  const parameterElementList = parameterDataList.map((parameterData) => (
    <Parameter key={parameterData.type} type={parameterData.type} value={parameterData.value} />
  ));

  return (
    <div
      className={classNames(
        advertDetailCss.advertDetail__parameterList,
        advertDetailParameterListCss.advertDetailParameterList,
      )}
    >
      <div className={advertDetailParameterListCss.advertDetailParameterList__header}>
        <FormattedMessage defaultMessage="Parameters:" />
      </div>
      <div className={advertDetailParameterListCss.advertDetailParameterList__list}>
        {parameterElementList}
      </div>
    </div>
  );
};

export { ParameterList };
